
import router from '../router/index'//路由
import CryptoJS from 'crypto-js'
import api from "@/api/index.js"; // 全局挂载请求

const tool = {}

tool.decryptAES = (encryptData) => {
    var key = CryptoJS.enc.Utf8.parse('31E784126CE449B694UCE41EAEDBF0AA'); // 密钥
    var iv = CryptoJS.enc.Utf8.parse('a2xhcgAAABLAAAAM'); // 初始化向量

    // 这是加密的数据（Base64编码）
    const encryptedData = encryptData;

    // 解密
    const decryptedBytes = CryptoJS.AES.decrypt({
        ciphertext: CryptoJS.enc.Base64.parse(encryptedData)
    }, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    // 将解密后的数据转换为字符串
    const decryptedData = decryptedBytes.toString(CryptoJS.enc.Utf8);

    return decryptedData


}//解密

tool.isMobile = () => {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag || false
}//是否是移动
tool.setToken = token => localStorage.setItem('token', token)
tool.getToken = () => localStorage.getItem('token')
tool.removeToken = () => localStorage.removeItem('token')
tool.indexArr = (item) => {
    let stepData = {}
    if (item == '登录') {
        stepData = {
            path: 'login',
            sort: 3
        }
    }

    if (item == '封面') {
        stepData = {
            path: 'cover',
            sort: 1
        }
    }
    return stepData
}
tool.menuArray = (data) => {
    let arr = data.setForm.stepArr.sort((a, b) => {
        return a - b
    })
    let stepData = []

    arr.forEach((item, index) => {

        let json = {
        }
        if (item == 1) {
            json.title = '基本信息'
            json.en_title = 'Information',
                json.path = 'personal',
                json.step = 1
        }
        if (item == 2) {
            json.title = '问卷'
            json.path = 'questionnaire'
            json.en_title = 'Questionnaire',
                json.step = 2

        }
        if (item == 4) {
            json.title = '预约'
            json.path = 'reservation'
            json.en_title = 'Reservation',
                json.step = 4
        }
        if (item == 5) {
            json.title = '审核'
            json.path = 'examine'
            json.en_title = 'Review ',
                json.step = 5

        }
        if (item == 7) {
            json.title = '完成'
            json.path = 'register'
            json.en_title = 'Completion',
                json.step = 7

        }

        if (index === 0) {
            json.isFrist = true
        }

        if (index === arr.length - 1) {
            json.isLast = true
        }
        if (json.path) {
            stepData.push(json)

        }
    })

    stepData.forEach((items, indexs) => {
        if (items.isFrist) {
            items.nextPath = stepData[indexs + 1].path
            return
        }
        if (items.isLast) {
            items.prePath = stepData[indexs - 1].path
            return
        }
        items.prePath = stepData[indexs - 1].path
        items.nextPath = stepData[indexs + 1].path
    })


    return stepData

}//处理菜单步骤

tool.setCookieWithExpiration = (label, value, s) => {
    var date = new Date();
    date.setTime(date.getTime() + (s * 1000)); // 设置过期时间为指定的天数之后  
    var expires = "; expires=" + date.toUTCString(); // 转换为GMT格式的字符串  
    document.cookie = label + "=" + (value || "") + expires + "; path=/"; // 设置cookie  
}

tool.getCookie = (label) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${label}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

tool.getExamineState = async () => {
    let projectId = sessionStorage.getItem('projectId') || ''
    let info = sessionStorage.getItem('info') ? JSON.parse(sessionStorage.getItem('info')) : {}
    let res = await api.getuserauditstatus()
    if (res.code == 200 || res.code == 204) {
        info.auditStatus = res.data
        sessionStorage.setItem('info', JSON.stringify(info))
        if (res.data == 1 && info.isStep == 7) {
            router.push({
                name: 'register',
                query: {
                    projectId
                }
            })
        }
    }
},

    tool.dateFormat = function (date, fmt = 'yyyy-MM-dd hh:mm:ss') {
        date = new Date(date)
        var o = {
            "M+": date.getMonth() + 1,                 //月份
            "d+": date.getDate(),                    //日
            "h+": date.getHours(),                   //小时
            "m+": date.getMinutes(),                 //分
            "s+": date.getSeconds(),                 //秒
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度
            "S": date.getMilliseconds()             //毫秒
        };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        }
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
            }
        }
        return fmt;
    }


tool.router = () => {

}//是否是移动

// 转base64编码
tool.getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader();
        let fileResult = "";
        reader.readAsDataURL(file); //开始转
        reader.onload = function () {
            fileResult = reader.result;
        };
        //转失败
        reader.onerror = function (error) {
            reject(error);
        };
        //转结束 resolve 出去
        reader.onloadend = function () {
            resolve(fileResult);
        };
    });
}
tool.loginOut = () => {
    localStorage.removeItem('token')
    sessionStorage.removeItem('info')

}

tool.getDate = () => {
    const currentTime = new Date();
    const year = currentTime.getFullYear();
    const month = currentTime.getMonth() + 1; // 月份从0开始，因此需要加1
    const day = currentTime.getDate();
    const hours = currentTime.getHours();
    const minutes = currentTime.getMinutes();
    const seconds = currentTime.getSeconds();
    return year + '-' + month + '-' + day + '  ' + hours + ':' + minutes + ':' + seconds
}


tool.randomString = (length) => {
    var str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var result = '';
    for (var i = length; i > 0; --i)
        result += str[Math.floor(Math.random() * str.length)];
    return result;
}
tool.dateFormat2 = function (startDateStr, endDateStr) {

    // 拆分开始日期字符串
    const startDateParts = startDateStr.split('-');
    const startYear = startDateParts[0];
    const startMonth = startDateParts[1];
    const startDay = startDateParts[2];

    // 拆分结束日期字符串
    const endDateParts = endDateStr.split('-');
    const endYear = endDateParts[0];
    const endMonth = endDateParts[1];
    const endDay = endDateParts[2];

    // 判断年、月是否相同
    if (startYear === endYear && startMonth === endMonth) {
        return `${startYear}年${startMonth}月${startDay}-${endDay}日`;
    } else {
        return `${startYear}年${startMonth}月${startDay}日 - ${endYear}年${endMonth}月${endDay}日`;
    }
}


export {
    tool
}

